import { render, staticRenderFns } from "./edite-country.vue?vue&type=template&id=5f321e1a&scoped=true"
import script from "./edite-country.vue?vue&type=script&lang=js"
export * from "./edite-country.vue?vue&type=script&lang=js"
import style0 from "./edite-country.vue?vue&type=style&index=0&id=5f321e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f321e1a",
  null
  
)

export default component.exports